import { NgModule } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../shared/shared.module';

import { HeaderComponent } from './header.component';

import { LinkWithSubDirective } from './link-with-sub.directive';

@NgModule({
    imports: [
        SharedModule,
        NgbDropdownModule,
        TranslateModule
    ],
    declarations: [
        LinkWithSubDirective,
        HeaderComponent
    ],
    exports: [
        HeaderComponent
    ]
})
export class HeaderModule {
}
